/**
 * @property COLOR
 * @type {Object}
 * @final
 */
export const COLOR = {
    BLUE_VERY_LIGHT: 'rgba(72, 136, 168, 1.0)',
    BLUE_VERY_LIGHT_02: 'rgba(72, 136, 168, 0.2)',
    BLUE_LIGHT: 'rgba(48, 96, 124, 1.0)',
    BLUE_MEDIUM_LIGHT: 'rgba(40, 80, 104, 1.0)',
    BLUE_MEDIUM: 'rgba(32, 64, 88, 1.0)',
    BLUE_MEDIUM_DARK: 'rgba(24, 48, 68, 1.0)',
    BLUE_MEDIUM_DARK_01: 'rgba(24, 48, 68, 0.1)',
    BLUE_DARK: 'rgba(18, 36, 52, 1.0)',
    BLUE_VERY_DARK: 'rgba(12, 22, 32, 1.0)',
    GREEN_LIGHT: 'rgba(193, 218, 205, 1)',
    GRAY_VERY_VERY_DARK: 'rgba(20, 20, 20, 1.0)',
    RED: 'rgba(230, 120, 110, 1.0)',
    RED_02: 'rgba(230, 120, 110, 0.2)',
    WHITE: 'rgba(255, 255, 255, 1.0)',
    WHITE_05: 'rgba(255, 255, 255, 0.5)'
};
